import { ApiError } from "@repo/api";

export type { ApiError };

export interface ParsedError {
  message: string;
  code: string | number | undefined;
}

export const parseError = (error: unknown): ParsedError => {
  if (error instanceof ApiError) {
    const data = error.data as { message?: string; code?: string } | undefined;
    return {
      message: data?.message || error.message || "Unexpected error",
      code: data?.code ?? error.status,
    };
  }

  if (error instanceof Error) {
    return {
      message: error.message,
      code: undefined,
    };
  }

  return {
    message: "An unknown error occurred",
    code: undefined,
  };
};
